import userContact from "../../../../components/userContact/userContact";
import { connect } from "react-redux";

function getTopThreeMembers(data) {
  if (!data && !data.length) return [];
  return data.sort((a, b) => b.revenueValue - a.revenueValue).slice(0, 3);
}

export default connect((state) => ({
  membersAtRiskRawDataLink: state.membership.membersAtRisk.membersAtRiskRawDataLink,
  showDetails: true,
  membersAtRiskNumber: state.membership.membersAtRisk.membersAtRiskNumber,
  total: state.membership.membersAtRisk.membersAtRiskNumber,
  data: getTopThreeMembers(state.membership.membersAtRisk.membersAtRisk)
}))(userContact);
